<template>
  <app-layout>
    <dashboard-layout>
      <template slot="header-out">
        <v-container class="px-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-card>
                <v-card-text>
                  <document-list
                    v-if="searchConfigReady"
                    entity="document"
                    :reload="reload"
                    @entitiesloaded="entitiesLoaded()"
                    :level="1"
                    search-input
                    :search-config="searchConfig"
                    default-icon="mdi-file-document-outline"
                    three-line
                    :from-user="true"
                  ></document-list>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import DocumentList from '../components/fiscal-obligations/DocumentList.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  components: {
    AppLayout,
    CalendarEvents,
    MyConsultantConversation,
    DashboardLayout,
    DocumentList,
  },

  data: () => ({
    year: 2024,
    years: [2020, 2021, 2022, 2023, 2024],
    searchConfigReady: false,
    formConfigReady: false,
    formConfig: {},
    searchConfig: {},
    reload: false,
  }),
  mounted() {
    this.getConfig();
    this.setInitialYear();
  },
  methods: {
    setInitialYear() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      const year = date.getFullYear();
      this.year = year;
    },
    getMonthDate(month) {
      return this.year + '-' + month;
    },
    getConfig() {
      this.searchConfigReady = false;
      this.formConfigReady = false;
      apiCtrl.get('/config/document').then(res => {
        console.log(res);
        if (res.data.data.hasOwnProperty('form')) {
          this.formConfig = res.data.data.form;
        }
        if (res.data.data.hasOwnProperty('search')) {
          this.searchConfig = res.data.data.search;
        }
        this.searchConfigReady = true;
        this.formConfigReady = true;
      });
    },
    uploadFile(type, month) {
      console.log({
        type: type,
        month: month,
      });
    },
    downloadFile() {
      console.log('download');
    },
    resetForm() {
      this.formData = {};
    },
    entitiesLoaded() {
      console.log('entitiesloaded');
      this.reload = false;
    },
    documentUploaded() {
      console.log('documentUploaded');
      this.reload = true;
    },
  },
};
</script>
